import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { ApiCallService } from './api-call.service';
import { ShowcaseProperty } from '../models/index';

@Injectable({ providedIn: 'root' })
export class ShowcasePropertyService extends BaseApiService {
  constructor(private apiCallService: ApiCallService) {
    super();
  }

  sendShowcasePropertyFeedback(
    agencyUuid: string,
    uuid: string,
    showcaseProperty: ShowcaseProperty
  ): Promise<ShowcaseProperty> {
    this.apiCallService.agencyUuid = agencyUuid;
    return this.apiCallService.put(
      '/showcases/' + uuid + '/showcase_properties/' + showcaseProperty.id,
      showcaseProperty
    );
  }
}
